import { makeStyles } from '@material-ui/core/styles';

export const SECTION_TITLE_MIN_WIDTH = 360;

const SECTION_INDENT = 20;
const SECTION_SPACING = 20;
const ROW_INDENT = 32;
const ROW_SPACING = 16;
const FIELD_INDENT = 32;
const FIELD_SPACING = 14;
const INLINE_FIELD_MARGIN_RIGHT = 12;
const INLINE_FIELD_MARGIN_BOTTOM = 8;
const FIELD_ENABLED_MARGIN_BOTTOM = 6;
const OPTION_SECTION_MARGIN_TOP = 14;
const OPTION_HEADER_LABEL_MARGIN_RIGHT = 4;
const OPTION_LIST_INDENT = 32;
const FIELD_ACTION_OFFSET = FIELD_INDENT;
const ROW_ACTION_OFFSET = ROW_INDENT;

const useTestInstanceTemplateStyles = makeStyles((theme) => ({
    sectionContainer: {
        paddingLeft: SECTION_INDENT,
        paddingBottom: SECTION_SPACING,
    },
    sectionTitleField: {
        minWidth: SECTION_TITLE_MIN_WIDTH,
    },
    rowContainer: {
        paddingLeft: ROW_INDENT,
        paddingBottom: ROW_SPACING,
    },
    fieldActionButton: {
        marginLeft: FIELD_ACTION_OFFSET,
    },
    rowActionButton: {
        marginLeft: ROW_ACTION_OFFSET,
    },
    addSectionButton: {
        alignSelf: 'flex-start',
    },
    inlineField: {
        display: 'inline-block',
        verticalAlign: 'bottom',
        marginRight: INLINE_FIELD_MARGIN_RIGHT,
        marginBottom: INLINE_FIELD_MARGIN_BOTTOM,
    },
    removeFieldButton: {
        float: 'right',
    },
    primaryIconButton: {
        color: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.primary.light,
    },
    fieldContainer: {
        paddingLeft: FIELD_INDENT,
        paddingBottom: FIELD_SPACING,
    },
    fieldEnabledToggle: {
        marginBottom: FIELD_ENABLED_MARGIN_BOTTOM,
    },
    booleanField: {
        display: 'inline-flex',
        flexDirection: 'column',
    },
    booleanFieldLabel: {
        paddingLeft: 12,
        lineHeight: 1,
    },
    optionSection: {
        marginTop: OPTION_SECTION_MARGIN_TOP,
        paddingLeft: OPTION_LIST_INDENT,
    },
    optionHeader: {
        display: 'flex',
        alignItems: 'center',
    },
    optionHeaderLabel: {
        marginRight: OPTION_HEADER_LABEL_MARGIN_RIGHT,
        fontWeight: 500,
    },
    optionList: {
        paddingLeft: OPTION_LIST_INDENT,
    },
    clearBoth: {
        clear: 'both',
    },
}));

export default useTestInstanceTemplateStyles;
